import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';

import FilterIcon from '../../../assets/icons/FilterIcon';
import FilterOffIcon from '../../../assets/icons/FilterOffIcon';
import StarCircleIcon from '../../../assets/icons/StarCircleIcon';

import RestrictComponent from '../../../components/shared/RestrictComponent';

import { routes } from '../../../constants';

import './sales-page.scss';

const settingsOptions = [
  {
    title: 'Leads',
    subTitle: 'Manage your sales leads',
    icon: <FilterIcon className='option-icn' />,
    url: routes.SALES_LEADS,
    roles: [],
  },
  {
    title: 'Active Surgeons',
    subTitle: 'Manage your active surgeons',
    icon: <StarCircleIcon className='option-icn' />,
    url: routes.SALES_ACTIVE_SURGEONS,
    roles: [],
  },
  {
    title: 'Lost Leads',
    subTitle: 'Manage your lost leads',
    icon: <FilterOffIcon className='option-icn' />,
    url: routes.SALES_LOST_LEADS,
    roles: [],
  },
];

const SalesPage = ({ currentTenant }) => {
  return (
    <div className='page-container'>
      <span className='page-title'>Sales</span>

      <div className='settings-body'>
        <Grid container spacing={1}>
          {
            settingsOptions.map((option) => (
              <RestrictComponent key={option.title}>
                <Grid item xs={12} sm={12} md={4} lg={3}>
                  <Link to={option.url}>
                    <div
                      className='settings-option'
                      key={`${option.title}_${Math.random()}`}
                      style={{ '--colorHover': `${currentTenant.colorPrimary}` }}
                    >
                      <span className='option-title'>{option.title}</span>
                      <span className='option-sub-t'>{option.subTitle}</span>
                      <div className='option-icn-cnt'>
                        <span>{React.cloneElement(option.icon, { color: 'var(--app-text)' })}</span>
                      </div>
                    </div>
                  </Link>
                </Grid>
              </RestrictComponent>
            ))
          }
        </Grid>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    currentTenant: state.tenant.currentTenant,
    userRole: state.user.currentUser.role,
  };
};

export default connect(mapStateToProps)(SalesPage);
